var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DocumentsTable } from '@web/components/Apps/DriveAdvancedSearch/DocumentsTable';
import { SearchFilters } from '@web/components/Apps/DriveAdvancedSearch/SearchFilters';
import { PAGINATION_PAGE_SIZE } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { getLimitOffset } from '@web/utility';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
export var DriveAdvancedSearch = function () {
    var _a, _b, _c, _d;
    var t = useTranslation().t;
    var currentFilters = useFilters();
    var navigateTo = useNavigateTo();
    var location = useLocation();
    var _e = useState({
        dateFrom: currentFilters.dateFrom,
        dateTo: currentFilters.dateTo,
        driveSearchType: currentFilters.driveSearchType
            ? currentFilters.driveSearchType
            : undefined,
        driveSearchAction: currentFilters.driveSearchAction
            ? currentFilters.driveSearchAction
            : undefined,
        driveSearchSubAction: currentFilters.driveSearchSubAction
            ? currentFilters.driveSearchSubAction
            : undefined,
        driveSearchTitle: (_a = currentFilters.driveSearchTitle) !== null && _a !== void 0 ? _a : undefined,
        orgUnit: currentFilters.orgUnit,
        user: currentFilters.user
    }), filters = _e[0], setFilters = _e[1];
    var _f = useState(currentFilters.hasInitialSearch || false), hasInitialSearch = _f[0], setHasInitialSearch = _f[1];
    var _g = useState(function () {
        var _a;
        if (currentFilters.hasInitialSearch) {
            return {
                dateFrom: currentFilters.dateFrom,
                dateTo: currentFilters.dateTo,
                driveSearchType: currentFilters.driveSearchType
                    ? currentFilters.driveSearchType
                    : undefined,
                driveSearchAction: currentFilters.driveSearchAction
                    ? currentFilters.driveSearchAction
                    : undefined,
                driveSearchSubAction: currentFilters.driveSearchSubAction
                    ? currentFilters.driveSearchSubAction
                    : undefined,
                driveSearchTitle: (_a = currentFilters.driveSearchTitle) !== null && _a !== void 0 ? _a : undefined,
                orgUnit: currentFilters.orgUnit,
                user: currentFilters.user
            };
        }
        return filters;
    }), searchFilters = _g[0], setSearchFilters = _g[1];
    var _h = getLimitOffset(currentFilters.page, PAGINATION_PAGE_SIZE), limit = _h.limit, offset = _h.offset;
    var _j = trpc.documentsList.useQuery({
        limit: limit,
        offset: offset,
        filters: {
            type: searchFilters.driveSearchType,
            action: searchFilters.driveSearchAction,
            subAction: searchFilters.driveSearchSubAction,
            title: searchFilters.driveSearchTitle,
            actionsBy: searchFilters.user,
            orgUnitId: searchFilters.orgUnit,
            dateFrom: searchFilters.dateFrom,
            dateTo: searchFilters.dateTo
        }
    }, {
        enabled: hasInitialSearch
    }), data = _j.data, isLoading = _j.isLoading;
    var handleFiltersChange = function (newFilters) {
        setFilters(newFilters);
    };
    var handleSearch = function () {
        setSearchFilters(__assign(__assign({}, filters), { orgUnit: currentFilters.orgUnit, dateFrom: currentFilters.dateFrom, dateTo: currentFilters.dateTo }));
        setHasInitialSearch(true);
        navigateTo({
            pathname: location.pathname,
            newFilters: {
                hasInitialSearch: true
            }
        });
    };
    return (_jsxs("div", __assign({ className: "flex flex-col space-y-4" }, { children: [_jsxs("h2", __assign({ className: "flex items-center text-xl leading-7 font-semibold gap-1" }, { children: [_jsx("img", { src: "https://staging.workalizer.com/assets/img/email_icons/google-drive-icon.png", alt: "Google Drive", width: 32, height: 32 }), t('app.driveAdvancedSearch.driveAdvancedSearch')] })), _jsx(SearchFilters, { filters: filters !== null && filters !== void 0 ? filters : {}, onChange: handleFiltersChange, onSearch: handleSearch }), hasInitialSearch && (_jsx(DocumentsTable, { data: (_b = data === null || data === void 0 ? void 0 : data.data) !== null && _b !== void 0 ? _b : [], total: (_c = data === null || data === void 0 ? void 0 : data.total) !== null && _c !== void 0 ? _c : 0, pageSize: PAGINATION_PAGE_SIZE, isLoading: hasInitialSearch && isLoading, page: (_d = currentFilters.page) !== null && _d !== void 0 ? _d : 1 }))] })));
};
